export default __webpack_public_path__ + "static/media/keyboard_arrow_left.4e6fac3b.svg";